export const initialProductState = (): ProductState => ({
  filter: {
    price: '',
  },
  filtered: {
    price: {
      meta: {
        total: 0,
        currentPage: 0,
        lastPage: 0,
        perPage: 0,
        next: 0,
        prev: 0,
      },
      data: [],
    },
  },
  limit: {
    promotions: 50,
  },
  page: {
    promotions: 1,
  },
  autocompletes: {
    promotion: {
      ean: {
        filter: {
          column: 'ean',
          value: '',
          limit: 15,
        },
        data: [],
      },
      code: {
        filter: {
          column: 'code',
          value: '',
          limit: 15,
        },
        data: [],
      },
      resume: {
        filter: {
          column: 'resume',
          value: '',
          limit: 15,
        },
        data: [],
      },
      type: {
        filter: {
          column: 'type',
          value: '',
          limit: 15,
        },
        data: [],
      },
      promotion: {
        filter: {
          column: 'promotion',
          value: '',
          limit: 15,
        },
        data: [],
      },
      regularPrice: {
        filter: {
          column: 'regularPrice',
          value: '',
          limit: 15,
        },
        data: [],
      },
      promotionalPrice: {
        filter: {
          column: 'promotionalPrice',
          value: '',
          limit: 15,
        },
        data: [],
      },
    },
    offline: {
      ean: {
        filter: {
          column: 'ean',
          value: '',
          limit: 15,
        },
        data: [],
      },
      code: {
        filter: {
          column: 'code',
          value: '',
          limit: 15,
        },
        data: [],
      },
      resume: {
        filter: {
          column: 'resume',
          value: '',
          limit: 15,
        },
        data: [],
      },
      regularPrice: {
        filter: {
          column: 'regularPrice',
          value: '',
          limit: 15,
        },
        data: [],
      },
      promotionalPrice: {
        filter: {
          column: 'promotionalPrice',
          value: '',
          limit: 15,
        },
        data: [],
      },
      regularPriceOffline: {
        filter: {
          column: 'regularPriceOffline',
          value: '',
          limit: 15,
        },
        data: [],
      },
      promotionalPriceOffline: {
        filter: {
          column: 'promotionalPriceOffline',
          value: '',
          limit: 15,
        },
        data: [],
      },
      createdAt: {
        filter: {
          column: 'createdAt',
          value: '',
          limit: 15,
        },
        data: [],
      },
      updatedAt: {
        filter: {
          column: 'updatedAt',
          value: '',
          limit: 15,
        },
        data: [],
      },
    },
  },
  filters: {
    promotion: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
      },
    },
    offline: {
      filter: {
        page: 1,
        limit: 50,
        filter: [],
        orderBy: [],
      },
      data: {
        meta: {
          total: 0,
          lastPage: 1,
          currentPage: 1,
          perPage: 50,
        },
        data: [],
      },
    },
  },
});
